<template>
	<b-card class="p-05">
		<!--  -->
		<b-row>
			<b-col cols="12" lg="5" xl="4">
				<b-carousel
					ref="myCarouselSpecimen"
					:controls="S_PHOTOS.length > 1"
					:indicators="S_PHOTOS.length > 1"
					v-model="carrouselIdx"
					v-if="S_PHOTOS.length"
				>
					<b-carousel-slide
						class="rounded-lg overflow-hidden"
						v-for="(photo, index) in S_PHOTOS"
						:key="photo.photo_id"
					>
						<template #img>
							<b-img
								center
								class="sd-carousel-img aspect-square"
								@click="viewImage(index)"
								@error="handleImageError($event.target)"
								:src="photo.photo"
							/>
							<b-icon
								class="position-absolute text-primary bg-white rounded-circle"
								style="top: 1.5rem; right: 1.5rem; z-index: 9"
								:icon="photo.feature ? 'check-circle' : 'circle'"
								variant="primary"
								font-scale="2"
								:class="{ 'cursor-pointer': !photo.feature }"
								@click="setPrincipalPhoto(photo, index)"
								v-if="!isInvitado"
							/>
						</template>
					</b-carousel-slide>
					<b-button
						class="btn-icon position-absolute"
						variant="outline-primary"
						style="bottom: 1.5rem; right: 1.5rem; z-index: 9"
						@click="modalImage = true"
						v-if="!isInvitado"
					>
						<feather-icon size="20" icon="UploadIcon" class="text-white" />
					</b-button>
					<b-button
						class="btn-icon position-absolute"
						variant="danger"
						style="bottom: 5.5rem; right: 1.5rem; z-index: 9"
						@click="deleteCarouselPhoto"
						v-if="!isInvitado"
					>
						<feather-icon size="20" icon="TrashIcon" class="text-white" />
					</b-button>
				</b-carousel>
				<b-aspect
					class="position-relative d-flex align-items-center rounded-lg bg-secondary"
					aspect="1/1"
					v-else
				>
					<div class="font-weight-bolder text-white text-center" style="font-size: 3rem">
						{{ specimenData.alias }}
						<br />
						@{{ specimenData.plate }}
					</div>
					<b-button
						class="btn-icon position-absolute"
						variant="outline-primary"
						style="bottom: 1.5rem; right: 1.5rem; z-index: 9"
						v-if="!isInvitado"
					>
						<feather-icon @click="modalImage = true" size="20" icon="UploadIcon" class="text-white" />
					</b-button>
				</b-aspect>
				<div class="d-flex justify-content-center justify-content-md-start flex-wrap gap-x-2 gap-y-2 mt-2">
					<b-button
						:disabled="!this.isAdmin"
						class="d-flex justify-content-center align-items-center p-50 bg-smooth-primary"
						variant="flat-primary"
						@click="$emit('open-pedigree')"
					>
						<div class="mr-05 p-50 bg-primary bg-lighten-3 rounded">
							<img
								style="width: 2rem; height: 2rem"
								:src="require('@/assets/images/chicken-pedigree.svg')"
							/>
						</div>
						<div class="text-left">
							<span>PEDIGREE</span>
							<br />
							<small>Ver aqui</small>
						</div>
					</b-button>
					<b-button
						v-if="![2, 4, 6].includes(specimenData.category)"
						class="d-flex justify-content-center align-items-center p-50 bg-smooth-primary"
						variant="flat-primary"
						:disabled="Number(preparationCounter) == 0"
						@click="
							;(showPreparationDetail = !showPreparationDetail), (preparationDetailInfo = specimenData)
						"
					>
						<div class="mr-05 p-50 bg-primary bg-lighten-3 rounded">
							<img style="width: 2rem; height: 2rem" src="/training/icon.svg" />
						</div>
						<div class="text-left">
							<span v-b-tooltip.hover="`Puntaje de preparacion`">
								Preparacion: {{ Number(preparationCounter).toFixed(2) }}
							</span>
							<br />
							<small>Ver aqui</small>
						</div>
					</b-button>
					<b-button
						class="d-flex justify-content-center align-items-center p-50 bg-smooth-primary"
						variant="flat-primary"
						@click="
							;(clinicalHistoryModal.info = specimenData),
								(clinicalHistoryModal.show = !clinicalHistoryModal.show)
						"
					>
						<div class="mr-05 p-50 bg-primary bg-lighten-3 rounded">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="30"
								height="30"
								viewBox="0 0 512 512"
								fill="#2C3E50"
							>
								<path
									d="m11.996 196.313 3.504 1.28c7.387 2.696 15.402.305 20.219-5.413 61.761 22.543 65.566 22.484 77.804 33.91a78.15 78.15 0 0 0 26.684 16.379l147.8 53.945c29.2 10.66 55.325-21.258 39.731-47.766 19.649-6.941 28.035-29.945 17.485-47.902a33.496 33.496 0 0 0 8.707-4.613l66.734 143.445c.652 1.399 1.93 2.781 3.422 3.535l39.277 19.805c2.078 1.047 5.317 1.73 8.567 1.394l25.773 55.403a7.498 7.498 0 0 0 13.598-6.324l-25.778-55.414c2.344-2.262 3.91-5.168 4.454-7.438l10.152-42.8a7.678 7.678 0 0 0-.496-4.895l-25.668-55.172A7.498 7.498 0 1 0 460.367 254l22.504 48.367-51.773 24.086-5.844-12.562 5.41-2.52a7.496 7.496 0 0 0 3.637-9.96 7.498 7.498 0 0 0-9.961-3.638l-5.41 2.52-6.551-14.074 5.414-2.52a7.5 7.5 0 1 0-6.328-13.597l-5.41 2.52-6.547-14.075 5.41-2.516a7.5 7.5 0 0 0 3.637-9.965c-1.742-3.754-6.203-5.382-9.961-3.636l-5.41 2.52-6.547-14.075 5.41-2.52a7.5 7.5 0 0 0 3.637-9.96 7.504 7.504 0 0 0-9.965-3.637l-5.41 2.52-6.414-13.79 51.77-24.086 19.937 42.852a7.498 7.498 0 0 0 13.597-6.324l-21.351-45.899a32.847 32.847 0 0 0 9.261-13.527c6.254-17.133-2.546-36.059-19.683-42.309l-3.621-1.324c.957-3.422.758-7.183-.856-10.648l-3.195-6.875c-3.594-7.727-12.758-11.075-20.492-7.477l-19.324 8.988-.325-.117-14.336-30.816 1.672-.778c7.73-3.597 11.074-12.761 7.48-20.492l-3.199-6.87c-1.632-3.513-4.46-6.122-7.789-7.583.07-1.598.024-3.219-.164-4.855C361.86 12.94 347.227-1.16 334.516.078l-48.43 4.875a7.502 7.502 0 0 0-6.711 8.215 7.493 7.493 0 0 0 8.215 6.707c.12-.012 48.18-4.855 48.297-4.855 4.453 0 11.933 7.152 12.492 12.03.785 6.884-3.3 13.493-10.004 15.829L296.625 58c-11.398 4.125-11.414 20.25-.031 24.406 5.66 2.063 119.894 43.758 125.691 45.875 9.324 3.403 14.14 13.754 10.738 23.078-3.378 9.25-13.687 14.16-23.078 10.739l-61.351-22.395-43.805-15.988a7.499 7.499 0 0 0-9.613 4.476c-1.422 3.887.582 8.192 4.472 9.614l40.813 14.898c15.148 5.527 15.715 26.578 1.422 33.227a17.889 17.889 0 0 1-13.766.586l-40.812-14.895a7.494 7.494 0 0 0-9.614 4.473 7.494 7.494 0 0 0 4.473 9.613l40.813 14.898c15.02 5.48 15.906 26.489 1.421 33.227a17.89 17.89 0 0 1-13.765.59l-40.813-14.899c-3.89-1.418-8.195.582-9.613 4.473a7.5 7.5 0 0 0 4.473 9.617l40.812 14.895c9.324 3.402 14.14 13.758 10.738 23.078-3.402 9.328-13.757 14.144-23.082 10.738-161.054-58.781-156.789-55.437-169.386-67.199-15.008-14.016-22.035-14.82-81.852-36.652 2.703-7.41 48.758-133.598 50.992-139.711l16.118 5.883c12.285 4.484 26.105 4.617 34.168 2.433 91.265-24.516 68.3-19.535 109.41-23.676a7.492 7.492 0 0 0 6.707-8.21 7.493 7.493 0 0 0-8.211-6.712c-44.383 4.473-19.5-.68-111.559 24.051a47.306 47.306 0 0 1-25.375-1.976l-16.965-6.188c.27-7.687-4.367-15.027-11.972-17.805l-3.504-1.277C72.266 1.832 61.762 6.72 58.316 16.172L1.11 172.91c-3.453 9.453 1.43 19.953 10.887 23.402zm393.59-94.844a.425.425 0 0 1 .566.207l2.664 5.726-8.957-3.27zm-45.898-11.996c-2.254-.825-15.293-5.582-17.708-6.465l-2.386-5.133 12.082-5.621zm1.14-38.489a.426.426 0 0 1-.207.567c-4.875 2.27-37.332 17.367-42.625 19.832a.425.425 0 0 1-.566-.207l-1.895-4.074c29.582-10.715 36.012-11.543 42.79-21.5zm83.824 285.704 37.313-17.356-6.492 27.356c-.153.351-.434.64-.785.804l-1.903.883s-1.89.883-1.902.887a1.599 1.599 0 0 1-1.125.082zm-80.25-153.594c.028-.063.528-1.254.543-1.285l24.293-11.301 11.203 4.09-32.875 15.293zm-349.207-5.04L72.402 21.313c.606-1.652 2.496-2.55 4.172-1.937l3.504 1.277c1.656.606 2.547 2.516 1.942 4.172L24.813 181.562c-.606 1.657-2.516 2.547-4.176 1.942l-3.5-1.277c-1.664-.61-2.551-2.508-1.942-4.172zm0 0"
									data-original="#000000"
									class=""
								></path>
							</svg>
						</div>
						<div class="text-left">
							<span>Historial Clinico</span>
							<br />
							<small>Ver aqui</small>
						</div>
					</b-button>
					<b-button
						class="position-relative d-flex justify-content-center align-items-center p-50 bg-smooth-primary"
						variant="flat-primary"
						@click="openModalSiblings"
						v-if="
							(specimenData.cintillo != null && counterBrothers > 0) ||
							(specimenData.padrillo_description !== null &&
								specimenData.padrillo_description !== '' &&
								specimenData.madrilla_description !== null &&
								specimenData.madrilla_description !== '' &&
								specimenData.behavior === 'rajado') ||
							stepBrother.length > 0 ||
							siblings.length > 0 ||
							countHalf > 0 ||
							countChilds > 0
						"
					>
						<div class="mr-05 p-50 bg-primary bg-lighten-3 rounded">
							<img style="width: 2rem; height: 2rem" :src="require('@/assets/images/brothers.svg')" />
						</div>
						<div class="text-left">
							<span>Hermanos</span>
							<br />
							<small>Ver aqui</small>
						</div>
						<b-badge
							v-if="counterBrothers > 0 || countHalf > 0 || nephews > 0 || countChilds > 0"
							style="position: absolute; top: -0.5rem; right: -0.5rem; font-size: 0.9rem"
							:variant="`${
								counterBrothers ? 'primary' : countHalf ? '' : countChilds ? 'warning' : 'danger'
							}`"
						>
							{{
								counterBrothers
									? counterBrothers
									: countHalf
									? countHalf
									: nephews
									? nephews
									: countChilds
							}}
						</b-badge>
					</b-button>

					<b-button
						class="d-flex justify-content-center align-items-center p-50 bg-smooth-primary"
						variant="flat-primary"
						@click="showLineSpecimen.show = true"
						:disabled="specimenData.counter_timeline == 0"
					>
						<div class="mr-05 p-50 bg-primary bg-lighten-3 rounded">
							<svg
								style="width: 2rem; height: 2rem"
								xmlns="http://www.w3.org/2000/svg"
								version="1.0"
								width="512.000000pt"
								height="512.000000pt"
								viewBox="0 0 512.000000 512.000000"
								preserveAspectRatio="xMidYMid meet"
							>
								<g
									transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
									fill="#2C3E50"
									stroke="none"
								>
									<path
										d="M480 3854 c-99 -26 -197 -81 -276 -156 -87 -83 -132 -152 -170 -263 -25 -70 -28 -95 -28 -200 0 -108 3 -128 30 -205 17 -47 47 -111 68 -142 56 -85 162 -180 250 -223 74 -37 77 -40 177 -176 55 -77 104 -139 109 -139 5 0 54 62 109 139 100 137 102 139 179 176 89 44 220 167 266 250 58 105 80 190 80 315 1 192 -49 314 -184 451 -92 94 -178 144 -295 174 -75 19 -241 19 -315 -1z m310 -654 l0 -150 -150 0 -150 0 0 150 0 150 150 0 150 0 0 -150z"
									/>
									<path
										d="M2400 3854 c-99 -26 -197 -81 -276 -156 -87 -83 -132 -152 -170 -263 -25 -70 -28 -95 -28 -200 0 -108 3 -128 30 -205 17 -47 47 -111 68 -142 56 -85 162 -180 250 -223 74 -37 77 -40 176 -176 56 -77 105 -139 110 -139 4 0 54 62 109 139 100 137 102 139 179 176 89 44 220 167 266 250 58 105 80 190 80 315 1 192 -49 314 -184 451 -92 94 -178 144 -295 174 -75 19 -241 19 -315 -1z m310 -654 l0 -150 -150 0 -150 0 0 150 0 150 150 0 150 0 0 -150z"
									/>
									<path
										d="M4320 3854 c-99 -26 -197 -81 -276 -156 -87 -83 -132 -152 -170 -263 -25 -70 -28 -95 -28 -200 0 -108 3 -128 30 -205 17 -47 47 -111 68 -142 56 -85 162 -180 250 -223 74 -37 77 -40 177 -176 55 -77 104 -139 109 -139 5 0 54 62 109 139 100 137 102 139 179 176 89 44 220 167 266 250 58 105 80 190 80 315 1 192 -49 314 -184 451 -92 94 -178 144 -295 174 -75 19 -241 19 -315 -1z m310 -654 l0 -150 -150 0 -150 0 0 150 0 150 150 0 150 0 0 -150z"
									/>
									<path
										d="M2410 1720 l0 -170 -810 0 -810 0 0 165 0 165 -150 0 -150 0 0 -165 0 -165 -245 0 -245 0 0 -155 0 -155 2560 0 2560 0 0 155 0 155 -245 0 -245 0 0 165 0 165 -150 0 -150 0 0 -165 0 -165 -810 0 -810 0 0 170 0 170 -150 0 -150 0 0 -170z"
									/>
								</g>
							</svg>
						</div>
						<div class="text-left">
							<span>Linea de tiempo</span>
							<br />
							<small>Ver aqui</small>
						</div>
					</b-button>
					<b-button
						class="position-relative d-flex justify-content-center align-items-center p-50 bg-smooth-primary"
						variant="flat-primary"
						@click="
							;(availableTracking.info = { specimen: specimenData }),
								(availableTracking.show = !availableTracking.show)
						"
						v-if="![2, 3, 4, 5, 6].includes(specimenData.category)"
					>
						<div class="mr-05 p-50 bg-primary bg-lighten-3 rounded">
							<svg
								style="width: 2rem; height: 2rem"
								xmlns="http://www.w3.org/2000/svg"
								version="1.1"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								width="512"
								height="512"
								viewBox="0 0 64 64"
								fill="#2C3E50"
							>
								<g>
									<path
										d="M60.226 29.5a2.5 2.5 0 0 0-2.5 2.5A25.726 25.726 0 1 1 32 6.274a2.5 2.5 0 1 0 0-5A30.726 30.726 0 1 0 62.726 32a2.5 2.5 0 0 0-2.5-2.5z"
										opacity="1"
										data-original="#000000"
										class=""
									></path>
									<path
										d="M32 12.726a2.5 2.5 0 0 0-2.5 2.5v17.71a2.5 2.5 0 0 0 .732 1.767l11.162 11.161a2.5 2.5 0 0 0 3.535-3.535L34.5 31.9V15.226a2.5 2.5 0 0 0-2.5-2.5zM41.517 10.443h8.545L39.765 20.74a2.5 2.5 0 0 0 1.767 4.268h14.565a2.5 2.5 0 0 0 0-5h-8.53L57.864 9.71a2.5 2.5 0 0 0-1.767-4.268h-14.58a2.5 2.5 0 0 0 0 5z"
										opacity="1"
										data-original="#000000"
										class=""
									></path>
								</g>
							</svg>
						</div>
						<div class="text-left">
							<span>Historial Descansos</span>
							<br />
							<small>Ver aqui</small>
						</div>
					</b-button>

					<b-button
						class="position-relative d-flex justify-content-center align-items-center p-50 bg-smooth-primary"
						variant="flat-primary"
						@click="openTripDetail(specimenData)"
						:disabled="specimenData.counter_trip === 0"
					>
						<div class="mr-05 p-50 bg-primary bg-lighten-3 rounded">
							<img style="width: 2rem; height: 2rem" :src="require('@/assets/images/trip.svg')" />
						</div>
						<div class="text-left">
							<span>Trip</span>
							<br />
							<small>Ver aqui</small>
						</div>
						<b-badge
							v-if="specimenData.counter_trip > 0"
							variant="primary"
							style="top: -8px; right: -8px"
							class="position-absolute"
						>
							{{ specimenData.counter_trip }}
						</b-badge>
					</b-button>

					<b-button
						class="position-relative d-flex justify-content-center align-items-center p-50 bg-smooth-primary"
						variant="flat-primary"
						@click="openIncidenceDetail(specimenData)"
					>
						<div class="mr-05 p-50 bg-primary bg-lighten-3 rounded">
							<feather-icon class="text-primary" icon="AlertOctagonIcon" size="26" />
						</div>
						<div class="text-left">
							<span>Incidencias</span>
							<br />
							<small>Ver aqui</small>
						</div>
						<b-badge
							variant="primary"
							style="top: -8px; right: -8px"
							class="position-absolute"
							v-if="incidencesCounter > 0"
						>
							{{ incidencesCounter }}
						</b-badge>
					</b-button>
				</div>
			</b-col>
			<b-col class="mt-2 mt-md-0" cols="12" lg="7" xl="8">
				<GeneralInfoDescription
					@update-status="$emit('update-status')"
					@custom-action="handleActionDescription"
					:specimen="specimenData"
					:arrayStatus="arrayStatus"
					:loadingData="loadingData"
					:loadingLine="loadingLine"
					:stepBrother="stepBrother"
					:siblings="siblings"
				/>
			</b-col>
		</b-row>
		<!--  -->
		<custom-light-box
			:items="images"
			:index="indexShow"
			:effect="'fade'"
			@close="indexShow = null"
			@on-click-info="openInfo"
		/>
		<!--  -->
		<b-modal title="Detalle" size="xl" v-model="aliveChickensDetailModal" hide-footer>
			<specimen-chicken-alives-detail :specimenData="specimenData"></specimen-chicken-alives-detail>
		</b-modal>
		<ModalUploadImageSpecimen
			v-if="modalImage"
			@hidden="modalImage = false"
			:specimen="specimenData"
			@set-index-carrousel="$refs.myCarouselSpecimen.setSlide(0)"
		/>
		<b-modal
			id="modal-primary"
			ok-only
			ok-title="Agregar"
			modal-class="modal-primary"
			centered
			title="Agregar criador"
			v-model="addCriadorModal"
			@ok.prevent="saveRival"
		>
			<b-row>
				<b-col cols="12">
					<b-form-group label="Nombre" label-for="criadorName">
						<b-form-input id="criadorName" v-model="criadorObject.name" />
					</b-form-group>
				</b-col>
			</b-row>
		</b-modal>
		<b-modal
			id="modal-primary"
			ok-only
			ok-title="Agregar"
			modal-class="modal-primary"
			centered
			title="Agregar color"
			v-model="addColorModal"
			@ok.prevent="saveColor"
		>
			<b-row>
				<b-col cols="12">
					<b-form-group label="Femenino" label-for="femenino">
						<b-form-input id="femenino" v-model="colourObject.female" />
					</b-form-group>
					<b-form-group label="Masculino" label-for="masculino">
						<b-form-input id="masculino" v-model="colourObject.male" />
					</b-form-group>
				</b-col>
			</b-row>
		</b-modal>
		<div class="loading-line-breeder" v-show="loadingLine">
			<p class="mb-0 mr-1">Los cambios estarán disponibles en unos momentos.</p>
			<FeatherIcon icon="RefreshCcwIcon" size="18" class="mr-50 text-primary icon" />
		</div>
		<ModalListSIblings
			:show="showListSiblings"
			@closing="showListSiblings = false"
			:specimen="specimenData"
			:showSiblings="showSiblings"
		/>
		<PreparationDetailModal
			:show="showPreparationDetail"
			:info="preparationDetailInfo"
			@closing="showPreparationDetail = false"
			:rating="preparationCounter"
		/>
		<ClinicalHistory
			:show="clinicalHistoryModal.show"
			:info="clinicalHistoryModal.info"
			@closing="clinicalHistoryModal.show = false"
			@refresh="$emit('update-status')"
		/>
		<BreederLine
			:show="breederLineModal.show"
			:info="breederLineModal.info"
			@closing="breederLineModal.show = false"
		/>
		<AddBreederLineModal
			:show="addBreederLineModal.show"
			:info="addBreederLineModal.info"
			@closing="addBreederLineModal.show = false"
			@new-line="handleNewBreederLine"
		/>

		<LineLife
			:show="showLineSpecimen.show"
			@closing="showLineSpecimen.show = false"
			:specimen="{
				id: specimenData.id,
				image:
					specimenData.photos.findIndex((p) => p.feature) >= 0
						? specimenData.photos[specimenData.photos.findIndex((p) => p.feature)].photo
						: null,
				plate: specimenData.plate,
				alias: specimenData.alias,
			}"
		/>
		<PadrilloAvailableTracking
			:show="availableTracking.show"
			:info="availableTracking.info"
			@closing="availableTracking.show = false"
		/>

		<TripDetailModal
			v-if="tripModal.show"
			:show="tripModal.show"
			:info="tripModal.info"
			:origin="'dashboard'"
			@closing="tripModal.show = false"
		/>

		<SpecimenIncidencesModal
			v-if="incidenceModal.show"
			:show="incidenceModal.show"
			:info="specimenData"
			@closing="incidenceModal.show = false"
		/>
	</b-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex"
import SpecimenChickenAlivesDetail from "./SpecimenChickenAlivesDetail.vue"
import SpecimenWeightTrackingModal from "../specimens-weight/SpecimenWeightTrackingModal.vue"
import SpecimenStatusChangedModal from "../components/SpecimenStatusChangedModal.vue"
import SpecimenService from "@/services/specimens.service"
import ModalUploadImageSpecimen from "./modals/ModalUploadImageSpecimen.vue"
import ModalTrackingFieldsSpecimen from "./modals/ModalTrackingFieldsSpecimen.vue"
import flatPickr from "vue-flatpickr-component"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import SpecimenAge from "@/components/specimens/SpecimenAge.vue"
import GeneralInfoDescription from "./GeneralInfoDescription.vue"
import ModalListSIblings from "./modals/ModalListSiblings.vue"
import preparacionService from "@/services/preparacion/default.service.js"
import PreparationDetailModal from "./PreparationDetailModal.vue"
import ClinicalHistory from "./modals/ClinicalHistory.vue"
import BreederLine from "./modals/BreederLine.vue"
import AddBreederLineModal from "@/views/amg/specimens/components/AddBreederLineModal.vue"
import CardLineBreeder from "./CardLineBreeder.vue"
import SmartIcon from "@/icons/SmartIcon.vue"
import LineLife from "./modals/LineLife.vue"
import PadrilloAvailableTracking from "../../encaste/posturas/modals/PadrilloAvailableTracking.vue"
import TripDetailModal from "@/views/amg/preparacion/components/recommendedSpecimens/TripDetailModal.vue"
import SpecimenIncidencesModal from "@/views/amg/videolibrary/incidences/IncidencesModal.vue"
import IncidencesService from "@/services/incidences.service"

export default {
	props: {
		specimenData: {
			type: Object,
			required: true,
		},
		loadingData: {
			type: Boolean,
		},
		loadingLine: {
			type: Boolean,
		},
	},
	components: {
		SpecimenChickenAlivesDetail,
		SpecimenWeightTrackingModal,
		SpecimenStatusChangedModal,
		ModalUploadImageSpecimen,
		ModalTrackingFieldsSpecimen,
		flatPickr,
		SpecimenPlate,
		SpecimenAge,
		GeneralInfoDescription,
		ModalListSIblings,
		PreparationDetailModal,
		ClinicalHistory,
		BreederLine,
		AddBreederLineModal,
		CardLineBreeder,
		SmartIcon,
		LineLife,
		PadrilloAvailableTracking,
		TripDetailModal,
		SpecimenIncidencesModal,
	},
	async mounted() {
		this.isPreloading()
		await Promise.all([
			this.getCountersGenderBrothers(),
			this.getSpecimenStatusTrackings(),
			this.A_GET_ORIGINS_SPECIMENS(),
			this.A_GET_BREEDERS(),
			this.getUsersByRole(),
			this.A_GET_CATEGORIES_SPECIMENS({
				specimen_id: this.specimenData.id,
			}),
			this.A_GET_COLORS_SPECIMENS(this.specimenData.gender),
		])
		this.isPreloading(false)
		this.M_SET_PHOTOS(this.specimenData.photos)
		this.specimenDataSecondary = { ...this.specimenData }
		this.params.specimen_id = this.specimenData.id
		this.currentGenerationRan = this.specimenData.ran_range
		this.initCounterBrothers()
		this.getPreparationCounter()
		this.getIncidencesCounterBySpecimen()
		this.buscarSibling()
		// assign breeder lines info for easy editing
		if (this.specimenData.breeder_line == null) {
			this.addBreederLineModal.info.lines = []
		} else {
			this.addBreederLineModal.info.lines = this.specimenData.breeder_line.map((l) => ({
				percentage: l.percentage,
				breeder_id: l.breeder_id,
				breederName: l.breeder_name,
			}))
		}
	},
	computed: {
		heightImage() {
			return ["xl"].includes(this.currentBreakPoint) ? "40rem" : "30rem"
		},
		widthCarousel() {
			return this.currentBreakPoint === "md" ? "50%" : "100%"
		},
		topRight() {
			return ["xl"].includes(this.currentBreakPoint) ? "bottom: 36rem; right: -20%;" : "top: -884%; right: -19%;"
		},
		borderRight() {
			return ["lg", "xl"].includes(this.currentBreakPoint) ? "border-right border-3" : ""
		},
		genderSpecimen() {
			return [1, 3, 5].includes(this.specimenData.category) ? "MACHO" : "HEMBRA"
		},
		isEncaste() {
			return this.specimenData.cintillo_ala !== null
		},
		isCamada() {
			return this.specimenData.origin === 1
		},
		hasCriador() {
			return [2, 3, 5, 6].includes(this.specimenData.origin)
		},
		...mapState("statusSpecimens", ["arrayUsers"]),
		...mapState("createEditSpecimen", [
			"S_EDIT_SPECIMEN",
			"S_CATEGORIES_SPECIMENS",
			"S_COLORS_SPECIMENS",
			"S_ORIGINS_SPECIMENS",
			"S_BREEDERS",
			"S_IMAGE_TO_UP",
			"S_PHOTOS",
			"S_GENDERS_SPECIMENS",
			"S_TRACKING_FIELDS",
			"S_PADRILLOS",
			"S_MADRILLAS",
		]),
		unknowBreederLine() {
			if (!this.specimenData.breeder_line) return 100
			let total = this.specimenData.breeder_line.reduce((acc, val) => acc + val.percentage, 0)
			return 100 - total
		},
	},
	data() {
		return {
			config: {
				altInput: true,
				altFormat: "F j, Y",
				dateFormat: "Y-m-d",
				locale: Spanish,
			},
			modal_image: false,
			aliveChickensDetailModal: false,
			images: [],
			indexShow: null,
			specimenWeightListController: false,
			specimenStatusController: false,
			selectedSpecimen: {},
			arrayStatus: [],
			modalOpenCategory: false,
			arrayCategorySpecimen: [],
			categorySpecimen: null,
			modalOpenColor: false,
			arrayColorSpecimen: [],
			colorSpecimen: null,
			modalOpenOrigins: false,
			arrayOriginsSpecimen: [],
			originSpecimen: null,
			modalOpenPlate2: false,
			plate2Specimen: null,
			modalImage: false,
			params: {
				specimen_id: null,
				category_id: null,
				color_id: null,
				additional_plate: null,
				dob: null,
				price: null,
				breeder_id: null,
				origin_id: null,
				alias: null,
				plate: null,
				preparador_id: null,
				currency: null,
				gender: null,
				current_plate: null,
				previous_plate: null,
				padrillo: null,
				madrilla: null,
				typeTracking: null,
			},
			specimenDataSecondary: {},
			addWeightSpecimen: false,
			observations: null,
			typeModalStatus: 1,
			trackingModal: false,
			paramsModalTracking: {},
			addColorModal: false,
			addCriadorModal: false,
			colourObject: {
				male: null,
				female: null,
			},
			criadorObject: {
				name: null,
			},
			ranSpecimenModalController: false,
			currentGenerationRan: [],
			modalViewDefinitionAlias: {
				show: false,
				title: "Agregar definición de alias",
			},
			//
			showListSiblings: false,
			counterBrothers: 0,
			preparationCounter: 0,
			showPreparationDetail: false,
			preparationDetailInfo: {},
			clinicalHistoryModal: {
				show: false,
				info: {},
			},
			breederLineModal: {
				show: false,
				info: {},
			},
			addBreederLineModal: {
				show: false,
				info: {},
			},

			breederLineColors: ["success", "danger", "warning", "info"],
			carrouselIdx: 0,
			showLineSpecimen: {
				show: false,
				specimen_id: null,
			},
			availableTracking: { show: false, info: {} },
			showSiblings: false,
			stepBrother: [],
			siblings: [],
			specimen: {},
			countHalf: 0,
			countChilds: 0,
			nephews: 0,
			tripModal: {
				show: false,
				info: {},
			},
			incidenceModal: {
				show: false,
				info: {},
			},
			incidencesCounter: 0,
		}
	},

	methods: {
		...mapMutations("createEditSpecimen", [
			"M_SET_EDIT_SPECIMEN",
			"M_SET_PHOTOS",
			"M_SET_PADRILLOS",
			"M_SET_MADRILLAS",
		]),
		...mapActions("createEditSpecimen", [
			"A_GET_CATEGORIES_SPECIMENS",
			"A_GET_COLORS_SPECIMENS",
			"A_GET_ORIGINS_SPECIMENS",
			"A_GET_BREEDERS",
			"A_UPDATE_PRINCIPAL_PHOTO",
			"A_UPDATE_CATEGORY_SPECIMEN",
			"A_UPDATE_ORIGIN_SPECIMEN",
			"A_UPDATE_COLOR_SPECIMEN",
			"A_UPDATE_BREEDER_SPECIMEN",
			"A_UPDATE_ALIAS_SPECIMEN",
			"A_UPDATE_ADDITIONAL_PLATE_SPECIMEN",
			"A_UPDATE_PREPARADOR_SPECIMEN",
			"A_UPDATE_PRICE_SPECIMEN",
			"A_UPDATE_OBSERVATIONS_SPECIMEN",
			"A_UPDATE_DOB_SPECIMEN",
			"A_UPDATE_PADRILLO_SPECIMEN",
			"A_UPDATE_MADRILLA_SPECIMEN",
			"A_INSERT_TRACKING_FIELDS_SPECIMEN",
			"A_GET_TRACKING_FIELDS_SPECIMEN",
			"A_ADD_IMAGE_BY_ID",
			"A_UPDATE_PRINCIPAL_PHOTO",
			"A_GET_SPECIMENS_BY_CATEGORY",
			"A_UPDATE_PLATE_SPECIMEN",
			"A_UPDATE_SPECIMEN_FIELS",
			"A_GET_IMAGES_SPECIMEN",
		]),
		...mapActions("statusSpecimens", ["getUsersByRole"]),

		buscarSibling() {
			let hermanos = []
			let hermanastros = []

			this.specimenData.pa_ids.forEach((pa) => {
				if (
					pa.madrilla_id === this.specimenData.madrilla_id &&
					pa.padrillo_id === this.specimenData.padrillo_id
				) {
					hermanos.push(pa)
				} else {
					hermanastros.push(pa)
				}
			})
			this.specimenData.ma_ids.forEach((pa) => {
				if (
					pa.madrilla_id === this.specimenData.madrilla_id &&
					pa.padrillo_id === this.specimenData.padrillo_id
				) {
					hermanos.push(pa)
				} else {
					hermanastros.push(pa)
				}
			})

			this.stepBrother = hermanastros
			this.siblings = hermanos
		},

		handleImageError(target) {
			target.src = require("@/assets/images/rooster.jpg")
			target.parentElement.classList.add("failed-load")
		},

		openModalSiblings() {
			this.showListSiblings = !this.showListSiblings

			if (
				(this.specimenData.padrillo_description !== null &&
					this.specimenData.padrillo_description !== "" &&
					this.specimenData.madrilla_description !== null &&
					this.specimenData.madrilla_description !== "" &&
					this.specimenData.behavior === "rajado" &&
					!(this.specimenData.cintillo != null && this.counterBrothers > 0 && !this.siblings.length > 0)) ||
				this.stepBrother.length > 0
			) {
				this.showSiblings = true
			}
		},

		async setPrincipalPhoto(photo, index) {
			if (photo.feature) return
			const confirm = await this.showConfirmSwal({
				text: "cambiarás la imagen principal del ejemplar",
			})

			if (confirm.value) {
				try {
					const image = {
						id_specimens: this.specimenData.id,
						id: photo.photo_id,
					}
					await this.A_UPDATE_PRINCIPAL_PHOTO(image)
					this.S_PHOTOS.forEach((photo2) => (photo2.feature = 0))
					this.S_PHOTOS[index].feature = 1
					this.showSuccessToast("La imagen principal ha sido actualizada correctamente")
					this.specimenDataSecondary = { ...this.specimenData }
				} catch (error) {
					this.showErrorSwal(error)
				}
			}
		},
		async getCountersGenderBrothers() {
			const data = await SpecimenService.getCounterBrothersAndGender({ specimen_id: this.specimenData.id })
			// this.countersGender = data
			this.countHalf = data.half_brothers.chicks + data.half_brothers.specimens
			this.nephews = data.nephews.chicks + data.nephews.specimens
			this.countChilds = data.childs.chicks + data.childs.specimens
		},
		viewImage(index) {
			this.images = this.S_PHOTOS.map((item) => {
				return {
					src: item.photo,
					title: this.specimenData.alias + "  |  " + this.specimenData.plate,
				}
			})
			this.indexShow = index
		},
		openInfo(item) {
			this.$router.push({
				name: "detalle-ejemplar",
				params: { specimen_id: item.id },
			})
		},
		delete_specimen(id) {
			this.$swal({
				title: "Estas seguro?",
				text: "¡No podrás revertir esto!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3490dc",
				cancelButtonColor: "#e3342f",
				confirmButtonText: "Confirmar",
				customClass: {
					cancelButton: "btn btn-outline-danger ml-1",
					confirmButton: "btn btn-primary",
				},
				buttonsStyling: false,
			}).then((result) => {
				if (result.value) {
					axios.delete(`/api/specimens/${id}`).then((response) => {
						if (response.status == 200) {
							this.showToast(
								"success",
								"top-right",
								"Felicidades",
								"CheckIcon",
								"El ejemplar ha sido eliminado!"
							)
							this.$router.push("/ejemplares")
						}
					})
				}
			})
		},
		async getSpecimenStatusTrackings() {
			if (!this.arrayStatus.length) {
				this.arrayStatus = await SpecimenService.getAllStatusSpecimens()
			}
		},
		async saveRival() {
			try {
				await axios.post("/api/save-rival", {
					namerival: this.criadorObject.name,
				})
				this.addCriadorModal = false
				this.A_GET_BREEDERS()
			} catch (error) {
				this.showErrorSwal(error)
			}
		},
		async saveColor() {
			try {
				await axios.post("/api/save-color", {
					namecolor: this.colourObject.male,
					gender_specimen: 1,
				})
				await axios.post("/api/save-color", {
					namecolor: this.colourObject.female,
					gender_specimen: 2,
				})
				this.addColorModal = false
				this.A_GET_COLORS_SPECIMENS(this.specimenData.gender)
			} catch (error) {
				this.showErrorSwal(error)
			}
		},
		printRangedRanSpecimen(items) {
			// this.currentGenerationRan = items.filter((e) => e.generation == 1);
			this.ranSpecimenModalController = true
		},
		printOwnerRanSpecimen(items) {
			if (this.specimenData.is_ran_owner && !this.specimenData.ran_owner.length) return

			if (this.specimenData.is_ran_owner) {
				// this.currentGenerationRan = items.filter((e) => e.generation == 1);
			} else {
				this.currentGenerationRan = this.specimenData.ran_owner
			}

			this.ranSpecimenModalController = true
		},
		async initCounterBrothers() {
			const resp = await SpecimenService.getCounterBrothersAndGender({
				specimen_id: this.specimenData.id,
			})

			for (const [key, value] of Object.entries(resp.brothers.chicks)) {
				this.counterBrothers += parseInt(value)
			}
			for (const [key, value] of Object.entries(resp.brothers.specimens)) {
				this.counterBrothers += parseInt(value)
			}
			for (const [key, value] of Object.entries(resp.brothers.patas)) {
				this.counterBrothers += parseInt(value)
			}
		},
		async getPreparationCounter() {
			const { data } = await preparacionService.getDashbordResume({ id: this.specimenData.id })
			this.preparationCounter = Number(data.total)
		},
		colorizePoints(points) {
			if (points == 2.5) return "info"
			else if (points == null) return "secondary"
			else if (points > 2.5) return "success"
			else if (points < 2.5) return "danger"
		},
		async handleNewBreederLine(lines) {
			// this.loadingLine = true;
			this.$emit("toggleLine")
			// return;
			// this.isPreloading()
			await SpecimenService.updateBreederLine({ specimen_id: this.specimenData.id, lines })

			// //

			// this.isPreloading(false)
			// this.loadingLine = false;
			this.$emit("toggleLine")
			this.showToast("success", "top-right", "Ejemplar", "CheckIcon", "Guardado con exito")
			this.$emit("update-status")
		},
		handleActionDescription(e) {
			switch (e) {
				case "clinical-history":
					this.clinicalHistoryModal.info = this.specimenData
					this.clinicalHistoryModal.show = !this.clinicalHistoryModal.show
					break
				case "show-breeder-line":
					this.breederLineModal.show = !this.breederLineModal.show
					this.breederLineModal.info = this.specimenData
					break
				case "edit-breeder-line":
					this.addBreederLineModal.show = !this.addBreederLineModal.show
					break
				case "delete-specimen":
					this.delete_specimen(this.specimenData.id)
					break
			}
		},
		async deleteCarouselPhoto() {
			const targetIdx = Number(this.carrouselIdx)
			const { isConfirmed } = await this.showConfirmSwal({
				text: `Se eliminara una imagen del ejemplar ${this.specimenData.alias || this.specimenData.plate}`,
			})
			if (!isConfirmed) return
			const curPhoto = this.S_PHOTOS[targetIdx]
			this.isPreloading()
			await SpecimenService.removeSpecimenImage({ specimen_id: this.specimenData.id, id: curPhoto.photo_id })
			await this.A_GET_IMAGES_SPECIMEN(this.specimenData.id)
			this.isPreloading(false)
			this.showToast("success", "top-right", "Ejemplares", "CheckIcon", "La imagen se elimino correctamente")
		},
		openTripDetail(data) {
			this.tripModal.info = { specimen: data }
			// if (data.counter_trip) {
			// 	this.tripModal.show = true
			// }
			this.tripModal.show = true
		},
		openIncidenceDetail(data) {
			this.incidenceModal.info = data
			this.incidenceModal.show = true
		},
		async getIncidencesCounterBySpecimen() {
			this.isPreloading()
			try {
				const { data } = await preparacionService.getIncidencesCounterBySpecimenId(this.specimenData.id)
				this.incidencesCounter = data.total
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
	},
	watch: {
		"specimenData.breeder_line"(val) {
			if (this.specimenData.breeder_line == null) {
				this.addBreederLineModal.info.lines = []
			} else {
				this.addBreederLineModal.info.lines = this.specimenData.breeder_line.map((l) => ({
					percentage: l.percentage,
					breeder_id: l.breeder_id,
					breederName: l.breeder_name,
				}))
			}
		},
	},
}
</script>

<style lang="scss">
.muda-gray {
	filter: grayscale(2) !important;
}

.container-ran {
	img {
		width: 30px;
		height: 30px;
		object-fit: cover;
	}

	p {
		color: #e74c3c;
		margin-bottom: 0;
		padding-top: -4px;
		font-size: 10px;
	}
}

.w-92 {
	width: 92%;
}

.pxd-button {
	display: inline-flex;
	align-items: center;
	column-gap: 0.6em;
	transition: transform 500ms ease-in-out;

	img {
		width: 2.5em;
		height: 2.5em;
	}

	&:active {
		transform: scale(0.96, 0.96);
	}
}

.pxd-border {
	border: 3px solid #6a6e7a;

	.dark-layout & {
		border-color: #6a7289;
	}
}

.sd-avatar {
	padding: 3rem 2rem !important;

	@media screen and (min-width: 62em) {
		padding: 6rem 3rem !important;
		border-right: 2px solid #ebe9f1;

		.dark-layout & {
			border-color: #3b4253;
		}
	}
}

.sd-carousel-img {
	width: 100%;
	object-fit: cover;
	object-position: center;
	cursor: pointer;

	&.failed-load {
		border-radius: 0.35rem;
		overflow: hidden;
	}
}

.carousel-item.failed-load {
	border-radius: 0.32rem;
	overflow: hidden;
}

.d-shared-btn {
	height: 7.4ch;
}

.d-aspect-avatar {
	background-color: #b8b8b8;

	.dark-layout & {
		background-color: var(--dark-hard);
	}
}

.sp-uploaded-icon {
	position: absolute;
	bottom: 1.25rem;
	right: 1.5rem;
	z-index: 2;

	.sp-up-button {
		outline: none;
		border: none;
		border-radius: 00.3rem;
		padding: 0.5rem;
	}
}
</style>

<style scoped lang="scss">
@keyframes spin {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

.loading-line-breeder {
	position: fixed;
	bottom: 1rem;
	right: 1rem;
	height: 60px;
	width: 300px;
	padding-left: 20px;
	background: #fff;
	border-left: 2px solid var(--primary);
	border-top: 2px solid var(--primary);
	z-index: 10000;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 20px 25px 5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);

	.icon {
		animation: spin 1s linear infinite;
	}
}

.bg-smooth-primary {
	background-color: #edecf7;
}
</style>
